// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1Z8BJ","header":"Messages_header__2BXho"};